module.exports = __webpack_public_path__ + "static/media/wps-person.1c94310b.svg";